import {AxiosResponse} from 'axios';
import i18n from '@apps/Shared/translation/i18n';
import IFlyersService from './IFlyersService';
import {
  IGetFlyersResponse,
  IDownloadFlyerPostBody,
  IGetStoreFlyersResponse,
  IDownloadStoreFlyerPostBody,
  IOrderStoreFlyerPostBody, IGeneratePdfPostBody
} from './interfaces';
import {ENDPOINT} from "@apps/Shared/Services/Axios/Api";
import {Client} from "@apps/Shared/Services/Axios";
import {clearServerMessage, renderServerMessage} from "@apps/Shared/Utils/ServerMessage";
import {ICustomAxiosResponse} from "@apps/Shared/Services/Response.types";

class FlyersService implements IFlyersService {
    async GetFlyers() {
        let res: AxiosResponse<IGetFlyersResponse>;

        try {
            res = await Client('get', `${ENDPOINT.AssociationFlyers.Flyers()}`);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async GetStoreFlyers() {
        let res: ICustomAxiosResponse<IGetStoreFlyersResponse> = {
            errors: [],
        };

        await Client('get', `${ENDPOINT.StoreFlyers.Flyers()}`)
            .then((response: AxiosResponse<IGetStoreFlyersResponse>) => {
                clearServerMessage();
                res.response = response;
            })
            .catch((error: Record<string, any>) => {
                renderServerMessage('error', i18n.t('error.disruptions'));
                res.errors = error.response.data.errors;
                return error.response;
            });

        return res;
    }

    async DownloadStoreFlyer(body: IDownloadStoreFlyerPostBody) {
        let res: AxiosResponse;

        try {
            res = await Client('post', `${ENDPOINT.StoreFlyers.DownloadFlyer()}`, body);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async OrderStoreFlyer(body: IOrderStoreFlyerPostBody) {
        let res: AxiosResponse;

        try {
            res = await Client('post', `${ENDPOINT.StoreFlyers.OrderFlyer()}`, body);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async DownloadFlyer(body: IDownloadFlyerPostBody) {
        let res: AxiosResponse;

        try {
            res = await Client('post', `${ENDPOINT.AssociationFlyers.DownloadFlyer()}`, body);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }
    
    async AnalyzePdf(fileUrl: string) {
      let res: AxiosResponse;

      try {
        res = await Client('get', `${ENDPOINT.AssociationFlyers.AnalyzePdf(fileUrl)}`);
        clearServerMessage();
      } catch (error: any) {
        console.log(error);
        renderServerMessage('error', i18n.t('error.disruptions'));
        return error.response;
      }

      return res;
   }
  async GeneratePdf(body: IGeneratePdfPostBody) {
    let res: AxiosResponse;

    try {
      res = await Client('post', `${ENDPOINT.AssociationFlyers.GeneratePdf()}`, body);
      clearServerMessage();
    } catch (error: any) {
      console.log(error);
      renderServerMessage('error', i18n.t('error.disruptions'));
      return error.response;
    }

    return res;
   }
}

export default new FlyersService();
